export default "__VITE_ASSET__BuBFBMZp__"